import Vue from "vue";
import Vuex from "vuex";
import jQuery from "jquery";

Vue.use( Vuex );

export default new Vuex.Store( {
   state: {
      version: process.env.PACKAGE_VERSION || 'Production',
      loading_label: 'Loading...',
      country_list: [],
      promocode: null,
      trying: 0,
      step: 'about',
      loading: false,
      enrolled: false,
      plans: [],
      perks: [],
      payment: {
         cardNumber: '',
         cardExpiry: '',
         cardCvc: '',
         cardBrand: '',
         dataValue: '',
         dataDescriptor: '',
         messages: []
      },
      signup: {
         plan: 'basic',
         plan_details: {
            cost: 0
         },
         interests: [],
         referral: '',
         referral_other: '',
         vouched_bypass: false,
         address: {
            address1: null,
            address2: null,
            city: null,
            region: null,
            postal: null,
            country: null,
         },
         vouched: {
            id: null,
            changed: false,
            userPhoto: '',
            idPhoto: '',
            data: {
               firstname: null,
               lastName: null,
               state: null,
               dob: null,
               documentid: null
            },
            messages: []
         },
         ownership: {
            dvc: false,
            mvc: false,
            none: false
         }
      }
   },

   mutations: {
      set_value: function( state, payload ) {
         if ( payload ) {
            if ( payload.collection ) {
               Vue.set( state[ payload.collection ], payload.attribute, payload.data );
            } else {
               Vue.set( state, payload.attribute, payload.data );
            }
         }
      }
   },

   actions: {
      check_vouched: function (context, step) {

         // send Vouched job
         jQuery.ajax(
            '/wp-admin/admin-ajax.php',
            {
               dataType: 'json',
               method: 'POST',
               data: {
                  action: 'dvca_vouched_job_check',
                  signup: context.state.signup.vouched
               },
               success: function( response ) {

                  if (response['status'] == 200) {
                     context.state.signup.vouched.messages = response['errors'];
                     context.state.signup.vouched.changed = false;

                     context.commit( 'set_value', { attribute: 'loading', data: false } );
                     context.commit( 'set_value', { attribute: 'step', data: step } );
                     context.dispatch( 'gotop');

                  } else {

                     if (response['status'] == 402) {
                        context.state.signup.vouched.id = null;
                        context.state.signup.vouched.data = null;
                        context.state.signup.vouched.messages = response['errors'];
                        context.state.signup.vouched.changed = true;
                                          
                        context.commit( 'set_value', { attribute: 'loading', data: false } );
                        context.commit( 'set_value', { attribute: 'step', data: 'about' } );

                     } else {
                        if (context.state.trying < 3) {
                           console.log('trying: ', context.state.trying)
                           context.state.trying += 1;
                           setTimeout(function(){
                              context.commit( 'set_value', { attribute: 'loading_label', data: response['message'] } );
                              console.log("3 secs")
                              context.dispatch( 'check_vouched', step);
                           }, 3000);
                        } else {
                           context.state.trying = 0;

                           //
                           console.log('timeout')
                           context.state.signup.vouched.id = null;
                           context.state.signup.vouched.data = null;
                           context.state.signup.vouched.messages = response['errors'];
                           context.state.signup.vouched.changed = true;
                                             
                           context.commit( 'set_value', { attribute: 'loading', data: false } );
                           context.commit( 'set_value', { attribute: 'step', data: 'about' } );
                        }
                     }
                  }
               }
            }
        );


      },
      set_vouched: function (context, step) {
         context.dispatch( 'gotop');
         context.state.trying = 0;

         // send Vouched job
         jQuery.ajax(
            '/wp-admin/admin-ajax.php',
            {
               dataType: 'json',
               method: 'POST',
               data: {
                  action: 'dvca_vouched_job_post',
                  signup: context.state.signup,
                  vouched_bypass: context.state.signup.vouched_bypass ? 1 : 0,
               },
               success: function( response ) {

                  // bypass
                  if (response['status'] == 201) {
                     context.state.signup.vouched.id = response['vouched_id']
                     context.state.signup.vouched.data = response['data'];
                     context.state.signup.vouched.messages = response['errors'];
                     context.state.signup.vouched.changed = false;

                     context.commit( 'set_value', { attribute: 'loading', data: false } );
                     context.commit( 'set_value', { attribute: 'step', data: step } );
                     context.dispatch( 'gotop');


                  } else if (response['status'] == 200 || response['status'] == 403) {
                     context.state.signup.vouched.id = response['vouched_id']
                     context.state.signup.vouched.data = response['data'];
                     context.state.signup.vouched.messages = response['errors'];
                     context.state.signup.vouched.changed = false;

                     // start the timer to check the validation in 6 seconds
                     setTimeout(function(){
                        context.commit( 'set_value', { attribute: 'loading_label', data: response['message'] } );

                        console.log("6 secs")
                        context.dispatch( 'check_vouched', step);
                     }, 6000);

                  } else {
                     context.state.signup.vouched.id = null;
                     context.state.signup.vouched.data = null;
                     context.state.signup.vouched.messages = response['errors'];
                     context.state.signup.vouched.changed = true;
                                          
                     context.commit( 'set_value', { attribute: 'loading', data: false } );
                     context.commit( 'set_value', { attribute: 'step', data: 'about' } );
                  }
               },
               error: function () { 
                  context.state.signup.vouched.id = null;
                  context.state.signup.vouched.data = null;
                  context.state.signup.vouched.messages = "Unable to validate the information, please try again.";
                  context.state.signup.vouched.changed = true;
                                       
                  context.commit( 'set_value', { attribute: 'loading', data: false } );
                  context.commit( 'set_value', { attribute: 'step', data: 'about' } );
              }
            }
        );


      },
      step_control: function ( context, payload ) {
         let step = payload.to;
         context.dispatch( 'gotop');
         context.commit( 'set_value', { attribute: 'loading_label', data: 'Loading...' } );

         // validate Vouched identity
         if (context.state.step == "about" && (!context.state.signup.vouched.id || context.state.signup.vouched.changed)) {
            context.commit( 'set_value', { attribute: 'loading_label', data: 'Validating...' } );
            context.commit( 'set_value', { attribute: 'loading', data: true } );

            if ((context.state.signup.vouched.id != "" && context.state.signup.vouched.id != null )) {
               // remove the old job
               // send Vouched job
               jQuery.ajax(
                  '/wp-admin/admin-ajax.php',
                  {
                     dataType: 'json',
                     method: 'POST',
                     data: {
                        action: 'dvca_vouched_job_remove',
                        vouched_id: context.state.signup.vouched.id
                     },
                     success: function() {
                        context.dispatch( 'set_vouched', step);  
                     },
                     error: function (jqXHR, textStatus, errorThrown) { 
                        console.log(jqXHR, textStatus, errorThrown)
                        context.dispatch( 'set_vouched', step);  
                    }
                  }
               );
               
            } else {
               context.dispatch( 'set_vouched', step);
            }


         } else {

            if ( ( step === 'complete' ) && ( !context.state.enrolled ) ) {
               context.commit( 'set_value', { attribute: 'loading', data: false } );
               context.dispatch( 'create_payment' );
            } else {
               context.commit( 'set_value', { attribute: 'loading', data: false } );
               context.commit( 'set_value', { attribute: 'step', data: step } );
            }
         }
      },

      fetch_plans: function( context ) {
         context.commit( 'set_value', { attribute: 'loading', data: true } );

         if (window.DVCA_PARAMS["PROMO"]) {
            if (window.DVCA_PARAMS["PROMO"] != "") {
               context.state.promocode = window.DVCA_PARAMS["PROMO"];
               console.log(context.state.promocode)
            }
         }

         jQuery.ajax(
             '/wp-admin/admin-ajax.php',
             {
                dataType: 'json',
                method: 'GET',
                data: {
                   action: 'dvca_mr_get_plans'
                },
                success: function( response ) {
                   context.commit( 'set_value', { attribute: 'loading', data: false } );

                   if ( ( response ) && ( response.plans ) && ( response.perks ) ) {
                      context.commit( 'set_value', { attribute: 'plans', data: response.plans } );
                      context.commit( 'set_value', { attribute: 'perks', data: response.perks } );

                      var selected_plan = response.plans.filter(x => x.slug == context.state.signup.plan)[0];
                      context.commit( 'set_value', { collection: 'signup', attribute: 'plan_details', data: selected_plan } );
                      context.dispatch( 'gotop');
                   } else {
                      context.commit( 'set_value', { attribute: 'errors', data: 'An error occurred, and we could not load membership plan information. Reload to try again, or try again later.' } );
                   }
                },
                error: function (jqXHR, textStatus, errorThrown) { 
                  console.log(jqXHR, textStatus, errorThrown)
                  context.commit( 'set_value', { attribute: 'loading', data: false } );
              }
             }
         );


         // fetch the country list
         jQuery.ajax(
            '/wp-content/uploads/countries.json',
            {
               dataType: 'json',
               method: 'GET',
               success: function( country_db ) {
                  var countries = Object.keys(country_db).map(x => {return {
                     "id": x, 
                     "label": country_db[x], 
                     "label_full": x + ' - ' + country_db[x]
                  }})
                  context.state.country_list = countries;
               },
               error: function (jqXHR, textStatus, errorThrown) { 
                 console.log(jqXHR, textStatus, errorThrown)
             }
            }
        );
      },

      create_payment: function(context) {
         
         context.state.payment.messages = [];
         var env = window.DVCA_PARAMS["ENV"];

         if (env == 'development') {
            // fake data, because it needs a local SSL to test
            context.state.payment.dataValue = "eyJjb2RlIjoiNTBfMl8wNjAwMDUyNzNBQTJEQTNEQTA0N0UxMzYzMzg5REI5NUQxMDBGOTdCNTE2NEU2RUM0M0UxNzJDNjQ4RjBBQUZBOThDRUU3MkUzMUQ3QzdEOTQzOTk4M0UyMUFFMzU2MEQ1Qjc2RUFBIiwidG9rZW4iOiI5NjMxNjQ2OTY5MDI2MTUzNzA0NjAyIiwidiI6IjEuMSJ9";
            context.state.payment.dataDescriptor = "COMMON.ACCEPT.INAPP.PAYMENT";
            context.state.payment.cardNumber = "4242424242424242";
            context.state.payment.cardExpiry = "02/23";
            context.state.payment.cardCvc = "123";
            context.state.payment.cardBrand = "visa";
           

            context.commit( 'set_value', { attribute: 'loading', data: true } );
            context.dispatch( 'create_account' );

         } else {
            // Use the environment keys and parameters
            var authData = {
               clientKey: window.DVCA_PARAMS["AUTHORIZE_NET"]["KEY"],
               apiLoginID: window.DVCA_PARAMS["AUTHORIZE_NET"]["LOGINID"]
            }

            var expiration = (context.state.payment.cardExpiry).split("/");
            var expMonth = '0000' + String(expiration[0] && expiration[0].trim());
            var expYear = expiration[1] && expiration[1].trim();
            var cardNumber = (String(context.state.payment.cardNumber).trim()).replace(/\D+/g, "");

            var cardData = {
               cardNumber: cardNumber,
               month: expMonth.substr(-2, 2),
               year: expYear.substr(-2, 2),
               cardCode:  context.state.payment.cardCvc
            }

            var secureData = {
               authData: authData,
               cardData: cardData
            };

            
            window.AcceptVue.dispatchData(secureData, function(response) {
               if (response.messages.resultCode === "Error") {
                  var i = 0;
                  while (i < response.messages.message.length) {
                     context.state.payment.messages.push(response.messages.message[i].code + ": " + response.messages.message[i].text);
                     i = i + 1;
                  }
                  context.commit( 'set_value', { attribute: 'loading', data: false } );
                  context.dispatch( 'gotop');
               } else {

                  context.state.payment.dataValue = response.opaqueData.dataValue;
                  context.state.payment.dataDescriptor = response.opaqueData.dataDescriptor;

                  context.commit( 'set_value', { attribute: 'loading', data: true } );
                  context.dispatch( 'create_account' );
               }
            }); 
         }
      },

      create_account: function( context ) {
                  
         context.commit( 'set_value', { attribute: 'loading', data: true } );

         jQuery.ajax(
             '/rest/api/accounts/create',
             {
                dataType: 'json',
                method: 'POST',
                data: {
                  promocode: context.state.promocode,
                  vouched: context.state.signup.vouched,
                  vouched_id: context.state.signup.vouched.id,
                  vouched_bypass: context.state.signup.vouched_bypass ? "1" : "0",
                  vouched_first_name: context.state.signup.vouched.data ? context.state.signup.name : null,
                  vouched_last_name: context.state.signup.vouched.data ? context.state.signup.vouched.data.lastName : null,
                  vouched_region: context.state.signup.vouched.data ? context.state.signup.vouched.data.state : null,
                  vouched_dob: context.state.signup.vouched.data ? context.state.signup.vouched.data.dob : null,
                  vouched_documentid: context.state.signup.vouched.data ? context.state.signup.vouched.data.documentid: null,
                  payment_value: context.state.payment.dataValue,
                  payment_descriptor: context.state.payment.dataDescriptor,
                  payment_last4: String(context.state.payment.cardNumber).trim().substr(-4, 4),
                  payment_brand: context.state.payment.cardBrand,
                  name: context.state.signup.name,
                  email: context.state.signup.email,
                  phone: context.state.signup.phone,
                  address_address1: context.state.signup.address.address1,
                  address_address2: context.state.signup.address.address2,
                  address_city: context.state.signup.address.city,
                  address_region: context.state.signup.address.region,
                  address_postal: context.state.signup.address.postal,
                  address_country: context.state.signup.address.country,
                  password: context.state.signup.password,
                  interests: context.state.signup.interests,
                  plan: context.state.signup.plan,
                  referral: context.state.signup.referral,
                  referral_other: context.state.signup.referral_other,
                  monday_info: window.DVCA_PARAMS.MONDAY_INFO,
                  authorizenet_info: window.DVCA_PARAMS.AUTHORIZENET_INFO
                },
                success: function( response ) {
                   context.commit( 'set_value', { attribute: 'loading', data: false } );

                   if ( response ) {
                      if ( response.success ) {
                        context.commit( 'set_value', { attribute: 'enrolled', data: true } );
                        context.dispatch( 'step_control', { to: 'complete' } );
                        context.dispatch( 'go_dashboard');
                      } else {
                        context.commit( 'set_value', { attribute: 'errors', data: response.message } );
                        context.dispatch( 'gotop');
                      }
                   }
                },
                error: function (jqXHR, textStatus, errorThrown) { 
                  console.log(jqXHR, textStatus, errorThrown)
                  context.commit( 'set_value', { attribute: 'loading', data: false } );
                  context.dispatch( 'gotop');
              }
             }
         );
      },

      clear_screen: function( context ) {
         context.commit( 'set_value', { attribute: 'errors', data: '' } );
      },

      gotop() {
         window.scrollTo({
               top: 0,
               behavior: 'smooth',
         });
      },
      go_dashboard() {
         window.location.href="/dashboard";
      }
   },


   modules: {

   }
} );
